import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Spinner from '../../../../../components/Spinner';
import useFetch from '../../../../../hooks/useFetch';
import DashboardService from '../../../../../services/dashboard.service';
import { MonthYearValue } from './MonthYearFilter';
import { ViewMode } from './ViewModeToggle';

interface AvgInventoryDaysProps {
  period: MonthYearValue;
  viewMode: ViewMode;
}

const AvgInventoryDays: React.FC<AvgInventoryDaysProps> = ({ period, viewMode }) => {
  const { t } = useTranslation();
  const [kpi, setKpi] = useState<{ avg_days_value: number; avg_days_qty: number } | null>(null);

  const { loading } = useFetch({
    service: DashboardService,
    func: 'avgInventoryDays',
    payload: { month: period.month, year: period.year },
    dependency: [period.month, period.year],
    onSuccess: (response: any) => {
      setKpi(response || null);
    },
  });

  const days = viewMode === 'value'
    ? (kpi?.avg_days_value ?? 0)
    : (kpi?.avg_days_qty ?? 0);

  const description = viewMode === 'value'
    ? t('dashboard.pageTexts.avgInventoryDays.descriptionValue')
    : t('dashboard.pageTexts.avgInventoryDays.descriptionQty');

  return (
    <div className="col-sm-6 col-xl-3">
      <div className="card">
        <div className="card-body">
          {loading ? (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 80 }}>
              <Spinner variant="primary" />
            </div>
          ) : (
            <div className="d-flex justify-content-between align-items-start">
              <div className="me-1">
                <p className="text-heading mb-1">{t('dashboard.pageTexts.avgInventoryDays.title')}</p>
                <div className="d-flex align-items-center">
                  <h4 className="mb-1 me-2">{days} <small className="text-muted fs-6">days</small></h4>
                </div>
                <p className="text-muted small mb-0">{description}</p>
              </div>
              <div className="avatar pe-none">
                <div className="avatar-initial bg-label-warning rounded-3">
                  <div className="ri-calendar-check-line ri-26px" />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AvgInventoryDays;
